import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {MaterialReactTable} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Step,
    StepLabel,
    Stepper,
    Tooltip
} from "@mui/material";
import Box from "@mui/material/Box";
import PackagingSetService from "../../../../../API/model-estimate/packaging/PackagingSetService";
import Typography from "@mui/material/Typography";
import ButtonCreate from "../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import PackagingUnitTable from "./PackagingUnitTable";
import PackagingUnitService from "../../../../../API/model-estimate/packaging/PackagingUnitService";
import ButtonBack from "../../../button/ButtonBack";
import TextFieldValidation from "../../customer-detales/TextFieldValidation";

const steps = [
    'Eд. упаковки',
    'Порядок',
];

const PackagingItemTable = ({id, article, data, setData, tableOptions, tableOptionsHandle, handleModalAlert}) => {
    const [modal, setModal] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);

    const handleDeleteRow = useCallback(
        (row) => {
            PackagingSetService.deletePackagingUnitById(id, row.id)
                .then(function () {
                    setData(prev => prev.filter(el => el.id !== row.id))
                    tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [data],
    );
    const handleEditRow = (row) => {
        setModal(true)
        setCurrentEditRowData(row)
    }
    const handleClose = () => {
        setModal(false)
        setCurrentEditRowData(null)
    }
    const handleSubmit = (value, integer, close) => {
        if (currentEditRowData) {
            PackagingUnitService.updatePackagingSet(currentEditRowData.id, {number: integer})
                .then(function () {
                    setData(prev => prev.map(el => el.id === currentEditRowData.id ? {...el, number: integer} : el))
                    close()
                    handleModalAlert("Порядок изменён", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
        } else {
            PackagingSetService.addPackagingUnit(id, value.id, integer)
                .then(function (response) {
                    setData(prev => [...prev, response.data])
                    close()
                    tableOptionsHandle((prev) => ({...prev, totalElements: data.length + 1}))
                    handleModalAlert("Добавлены единицы упаковки", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
        }
    }

    const columns = useMemo(
        () => [
            {
                id: 'number',
                header: 'Порядок',
                accessorKey: 'number',
                maxSize: 100,
            },
            {
                id: 'name',
                header: 'Наименование',
                accessorFn: (row) => row.packagingUnit?.name,
                minSize: 450,
            },
            {
                id: 'weight',
                header: 'Вес',
                accessorFn: (row) => row.packagingUnit?.weight,
                minSize: 450,
            },
            {
                header: 'id',
                id: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
            },
        ],
        [data, setData],
    );
    const menuItem = [
        {type: "edit", text: "Изменить порядок", handler: handleEditRow},
        {type: "delete", text: "Удалить", handler: handleDeleteRow}
    ]
    return (
        <Box sx={{width: '1200px',}}>
            <Box
                sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
            >
                <Typography sx={{fontSize: "24px", fontWeight: 700}}>
                    Комплект упаковки артикул: {article}
                </Typography>
                <ButtonCreate
                    text={"Добавить ед. упаковки"}
                    width={230}
                    onClick={() => setModal(true)}
                />

            </Box>
            <MaterialReactTable
                selectAllMode={"all"}
                muiTableContainerProps={{
                    sx: {
                        width: '1200px',
                    }
                }}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        "&:first-of-type": {
                            padding: 0,
                            width: "50px",
                            height: "36px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: (theme) => theme.palette.text.light,
                            "& .MuiButtonBase-root": {
                                borderRadius: "4px",
                                width: "24px",
                                height: "24px",
                                opacity: 1,
                                margin: 0,
                                padding: 0,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                }
                            }
                        },
                        "& li": {
                            listStyleType: "none",
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            }
                        }
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                columns={columns}
                data={data}
                getRowId={(originalRow) => originalRow.id}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    return (el.type === "edit" || (el.type === "delete" && !row.original.blocked)) && <MenuItem
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                state={{showGlobalFilter: true, pagination: tableOptions,}}
                rowCount={tableOptions.totalElements}
                enableRowActions={true}
                enableToolbarInternalActions={false}
                initialState={{
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                    sorting: [{id: 'number', desc: false}],
                }}
                localization={MRT_Localization_RU}
            />
            {modal && <PackagingAddUnitModal
                open={modal}
                onClose={handleClose}
                handleSubmit={handleSubmit}
                handleModalAlert={handleModalAlert}
                currentEditRowData={currentEditRowData}/>}
        </Box>

    );
};
const PackagingAddUnitModal = ({open, onClose, handleSubmit, handleModalAlert, currentEditRowData}) => {
    const [data, setData] = useState([]);
    const [selectedString, setSelectedString] = useState({})
    const [values, setInteger] = useState({integer: ""})
    const [activeStep, setActiveStep] = useState(0)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }
    useEffect(() => {
        !currentEditRowData && PackagingUnitService.getAll().then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    useEffect(() => {
        if (currentEditRowData) {
            setActiveStep(1)
            setInteger({integer: currentEditRowData?.number})
        }
    }, [currentEditRowData]);

    const close = () => {
        setActiveStep(0)
        setSelectedString({})
        onClose()
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${activeStep === 0 ? "800px" : "500px"}`,
                borderRadius: 8,
            }
        }}>
            <Box style={{
                padding: 20,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>{currentEditRowData ? "Изменить порядок" : "Добавить единицы упаковки"}</DialogTitle>
                {!currentEditRowData && <Stepper
                    style={{width: 446}}
                    activeStep={activeStep}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>}
            </Box>
            <DialogContent>
                {activeStep === 0 ? <PackagingUnitTable
                        handleModalAlert={handleModalAlert}
                        data={data}
                        setData={setData}
                        modal={true}
                        selectedStringId={selectedString?.id}
                        setSelectedString={setSelectedString}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}/>
                    : <Box> <TextFieldValidation
                        name={"integer"}
                        value={values?.integer}
                        label="Порядок"
                        setCurrValues={setInteger}
                    /></Box>}
            </DialogContent>
            <DialogActions style={{padding: 20, display: "flex", justifyContent: "space-between"}}>
                <Box>{(activeStep !== 0 && !currentEditRowData) &&
                    <ButtonBack text={"Назад"} onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit text={"Отменить"} onClick={close}/>
                    <ButtonAdd
                        text={"Выбрать"}
                        onClick={activeStep === 0 ? () => setActiveStep(1) : () => handleSubmit(selectedString, values?.integer, close)}
                        disabled={(activeStep === 0 && !selectedString?.id) || (activeStep === 1 && !values?.integer)}
                    />
                </Box>
            </DialogActions>
        </Dialog>
    );
}

export default PackagingItemTable;